import styled from '@emotion/styled';
import vars from '@variables';
import { H3Atom } from '@atoms/text-atoms/text-atoms';

export const TabTitlesWrapper = styled.ul<{ colour: string }>`
  display: flex;
  overflow-x: hidden; /* Hide the scrollbar */
  white-space: nowrap; /* Keep tabs in a single line */
  grid-column: col1-start / col4-end;
  @media screen and (min-width: ${vars.breakPointTablet}) {
    grid-column: col1-start / col12-end;
  }
  position: relative;
  /* padding-bottom: list items padding-bottom + selected item margin-bottom - separator width */
  li {
    display: flex;
    flex-shrink: 0;
    list-style-type: none;
    text-align: center;
    ${H3Atom} {
      padding: 1rem 2rem;
      margin: 0;
      cursor: pointer;
    }
  }
  .selected {
    border-bottom: 0.6rem solid ${({ colour }) => colour};
  }

  ::-webkit-scrollbar {
    height: ${vars.scrollbarSize};
    @media (hover: hover) {
      height: ${vars.scrollbarSize_beta}; /* TODO: Remove once carousel allows easier scrolling on non-touch devices */
    }
  }
  ::-webkit-scrollbar-thumb {
    background: ${vars.coreDarkGrey};
    border-radius: ${vars.scrollbarSize};
  }
`;
